import { lazy } from 'react';

export const ReportPageLazy = lazy(() => import('./ReportPage'));
